import { DataSourceExecutionEvent } from "@mcleod/components";
import { LayoutUrl } from "@mcleod/core";
import { AutogenLayoutQualifierCodeQuickInfo } from "./autogen/AutogenLayoutQualifierCodeQuickInfo";

export class QualifierCodeQuickInfo extends AutogenLayoutQualifierCodeQuickInfo {
    private _showLink = true;

    sourceQualifierCodeAfterExecution(event: DataSourceExecutionEvent) {
        this.syncLink();
    }

    set showLink(value: boolean) {
        this._showLink = value;
        this.syncLink();
    }

    get showLink(): boolean {
        return this._showLink;
    }

    private syncLink() {
        this.textboxStandardCode.printableLabel.link = this._showLink
            ? LayoutUrl.createForUpdateMode("lme/dispatch/QualifierCode", this.activeRow?.getString("id", null))
            : null;
    }
}
